var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [{ icon: "cogs", page: _vm.page_title.toUpperCase() }],
        },
      }),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _vm.list_access
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4", md: "4", sm: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "mx-auto", attrs: { tile: "" } },
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-subheader",
                                {
                                  staticClass: "mt-3",
                                  staticStyle: { "font-size": "16px" },
                                },
                                [_vm._v("Configuración")]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-list-item-group",
                                {
                                  attrs: { color: "primary", mandatory: "" },
                                  model: {
                                    value: _vm.selectedItem,
                                    callback: function ($$v) {
                                      _vm.selectedItem = $$v
                                    },
                                    expression: "selectedItem",
                                  },
                                },
                                _vm._l(_vm.items, function (item, i) {
                                  return _c(
                                    "v-list-item",
                                    { key: i },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: item.icon },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", {
                                            domProps: {
                                              textContent: _vm._s(item.text),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "8", md: "8", sm: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "mx-auto", attrs: { tile: "" } },
                        [
                          _vm.selectedItem == 0
                            ? _c("MiEmpresa", {
                                attrs: {
                                  mainItem: _vm.mainItem,
                                  loading: _vm.loading_submit,
                                },
                                on: { createItem: _vm.createItem },
                              })
                            : _vm._e(),
                          _vm.selectedItem == 1
                            ? _c("Email", {
                                attrs: {
                                  mainItem: _vm.mainItem,
                                  loading: _vm.loading_submit,
                                  service: _vm.service,
                                },
                                on: { createItem: _vm.createItem },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }